import { render, staticRenderFns } from "./KpiCatalogStatus.vue?vue&type=template&id=d794c256"
import script from "./KpiCatalogStatus.vue?vue&type=script&lang=js"
export * from "./KpiCatalogStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports